import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import {
  SkanetrafikenAction, 
  setLocationPoints,
  setIsFetching,
  setTravelOptions,
  setFetchFailed,
} from './actions';

export const fetchLocationPoints = (startsWith: string) => {
  return async (dispatch: Dispatch<SkanetrafikenAction>): Promise<void> => {

    try {
      const response = await Api.get('SearchSkanetrafikenLocation', `startsWith=${ startsWith }`);
      const points: Julius.Website.SkanetrafikenPoint[] = await response.json();

      if (response.status === 200) {
        dispatch(setLocationPoints(points));
      } else {
        dispatch(setLocationPoints([]));
      }
    } catch (e) {
      dispatch(setLocationPoints([]));
    }
  };
};

export const fetchTravelOptions = (from: string, to: string, startTime: Date, endTime: Date, quantity: number, skanetrafikenID: number) => {
  return async (dispatch: Dispatch): Promise<void> => {

    const { isFetching } = Store.getState().skanetrafiken;

    if (isFetching) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const queryParams = `fromLocation=${ from }&toLocation=${ to }&goThereTime=${ startTime.toUTCString() }&goHomeTime=${ endTime.toUTCString() }&nbrOfTravelers=${ quantity }&itemID=${ skanetrafikenID }`;
      const response = await Api.get('SearchSkanetrafikenJourney', queryParams);

      if (response.status === 200) {
        const options: Julius.Website.TravelDataViewModel = await response.json();
        dispatch(setTravelOptions(options));
      } else {
        dispatch(setFetchFailed());
      }
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/PickSkanetrafiken/Redux/thunks.tsx